import React from 'react';
import { Box, Typography } from '@mui/material';
import { ProvenanceTab, ProvenanceSectionId } from '../wizard/ProvenanceTab';

interface StepProps {
  catalogItemId?: string;
  ownerId?: string | null;
}

const SECTIONS: ReadonlySet<ProvenanceSectionId> = new Set<ProvenanceSectionId>([
  'provenance-exhibitions',
]);

const NOTE =
  'List exhibitions where this object has been displayed, including dates, venues, and any notable details.';

/** Exhibitions promoted from ProvenanceTab into its own step. */
export const ExhibitionsStep: React.FC<StepProps> = ({ catalogItemId, ownerId }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    <Typography
      variant="body2"
      color="text.secondary"
      data-testid="exhibitions-step-note"
    >
      {NOTE}
    </Typography>
    <ProvenanceTab
      catalogItemId={catalogItemId}
      ownerId={ownerId}
      visibleSections={SECTIONS}
      flatSections
    />
  </Box>
);
